import { createSelector } from 'reselect';
import componentSelector from 'src/selectors/component';

export const sidebarOpenSelector = createSelector(
  componentSelector('sidebar'),
  (sidebar) => sidebar.get('open'),
);
